export default __webpack_public_path__ + "static/media/favicon.b98ccbf5.png";